import { FunctionComponent, PropsWithChildren, ReactNode } from 'react';
import classNames from 'classnames';
import { Icons } from '@monorepo/icons';
import {
  Flex,
  TextComponent,
  TextComponentProps,
  Tooltip,
} from '@monorepo/react-components';
import { IconsNames } from '@monorepo/types';

interface Props extends PropsWithChildren {
  tooltipText?: string | ReactNode;
  tooltipLevel?: TextComponentProps['level'];
  opacity?: number;
  absolute?: boolean;
}

const DashboardTooltip: FunctionComponent<Props> = ({
  children,
  tooltipText,
  tooltipLevel = 6,
  opacity = 0.3,
  absolute = true,
}) => (
  <Tooltip
    trigger="hover"
    title={tooltipText}
    arrow
    className={classNames('dashboard-tooltip', {
      'dashboard-tooltip__absolute': absolute,
    })}
  >
    <Flex
      gap={8}
      align="center"
      style={{
        opacity: opacity,
      }}
    >
      <TextComponent level={tooltipLevel}>
        <Icons iconName={IconsNames.QuestionCircle} />
      </TextComponent>
      {children}
    </Flex>
  </Tooltip>
);
export default DashboardTooltip;
